import { useState } from 'react'

import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Heading } from 'blaze-ui/Heading/Heading'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

import Styles from './ConfirmPriceIncreaseDrawer.module.scss'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { Button } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
import { PriceIncreaseMessage } from 'components/Growth/InviteTeamModal/components/PriceIncreaseMessage/PriceIncreaseMessage'

export const ConfirmPriceIncreaseDrawer = (
  props: DrawerProps & {
    onConfirm: () => void
    currentPlan: PaymentPlanKey
    newMemberCount: number
    isBillingMonthly: boolean
  },
) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const { drawersStore } = useRootStore()

  const handleConfirm = async () => {
    setIsProcessing(true)
    await props.onConfirm()
    setIsProcessing(false)
    drawersStore.closeDrawer()
  }

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content heightDynamic>
          <Drawer.InnerContent color="var(--light-100)">
            <Drawer.Top>
              <Drawer.Close icon={ChevronLeft} label="" />
              <Drawer.Title asChild>
                <Heading level={5}>Confirm your price increase</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container>
              <PriceIncreaseMessage
                currentPlan={props.currentPlan}
                isBillingMonthly={props.isBillingMonthly}
                newMemberCount={props.newMemberCount}
              />
              <div className={Styles.footer}>
                <Button isDisabled={isProcessing} onPress={handleConfirm} size="lg">
                  Confirm
                </Button>
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
